import {
  InvalidCPFException,
  InvalidDateException,
  InvalidEmailException,
  RequiredParamException,
} from "api/exceptions/InvalidParamException";
import {
  BetweenValuesException,
  GreaterThanException,
  GreaterThanOrEqualException,
  InvalidValueException,
  LengthStringException,
  MaxAndMinLengthStringException,
  MaxLengthStringException,
  MinLengthStringException,
  OnlyNumbersException,
} from "api/exceptions/InvalidValueException";
import { cpf as CPFValidator } from "cpf-cnpj-validator";
import { inputTextToDate, isDate, isNumber } from "utils";

export function validateRequiredField(
  field: string,
  value: any,
  acceptNumberZero: boolean = false
): boolean {
  if (value || (acceptNumberZero && value === 0)) return true;
  throw new RequiredParamException(field);
}

export function validateNotNegativeNumbers(field: string, value: number) {
  if (isNumber(value) && value >= 0) return true;
  throw new GreaterThanOrEqualException(value, 0, field);
}

export function validateFieldWithMatch(
  field: string,
  value: string,
  regex: RegExp
): boolean {
  const matches = regex.exec(String(value));
  if (matches && matches[0] === value) return true;
  throw new InvalidValueException(value, field);
}

export function validateFieldIsGreaterThan(
  field: string,
  value: any,
  valueToCompare: any
): boolean {
  if (value === undefined || value === null || value === "") return true;
  if (value > valueToCompare) return true;
  throw new GreaterThanException(value, valueToCompare, field);
}

export function validateFieldIsBetween(
  field: string,
  value: any,
  min: any,
  max: any
): boolean {
  if (min <= value && value <= max) return true;
  throw new BetweenValuesException(value, min, max, field);
}

export function validateFieldLength(
  field: string,
  value: string,
  { min, max, equal }: { min?: number; max?: number; equal?: number }
): boolean {
  const lng = String(value || "").length;

  //Igual a
  if (equal !== undefined) {
    if (lng === equal) return true;
    throw new LengthStringException(value, equal, field);
  }

  //Maior que
  if (min === undefined) {
    max = max || 0;
    if (lng <= max) return true;
    throw new MaxLengthStringException(value, max, field);
  }

  //Menor que
  if (max === undefined) {
    if (min <= lng) return true;
    throw new MinLengthStringException(value, min, field);
  }

  //Entre
  if (min <= lng && lng <= max) return true;
  throw new MaxAndMinLengthStringException(value, min, max, field);
}

export function validateEmail(field: string, email: string): boolean {
  const emailRegex = /^[\w._-]+@[a-z]+(\.[a-z]+){1,2}$/;
  const matches = emailRegex.test(email);

  if (matches) return true;
  throw new InvalidEmailException(field);
}

export function validateCPF(field: string, value: string): boolean {
  if (CPFValidator.isValid(value)) return true;
  throw new InvalidCPFException(field);
}

export function validateDate(field: string, date: any): boolean {
  if (typeof date === "string") {
    date = inputTextToDate(date);
  }

  if (isDate(date)) return true;
  throw new InvalidDateException(field);
}

export function validateOnlyNumbers(field: string, value: string): boolean {
  const regex = /^[0-9]+$/;
  const matches = regex.test(value);

  if (matches) return true;
  throw new OnlyNumbersException(value, field);
}
